import { createContext, useContext, useState, useCallback } from "react";
import { ui, contentMap } from "@/i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "de");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
    document.documentElement.lang = l;
  }, []);

  // static UI translation by dot-path, e.g. t("nav.home")
  const t = useCallback((path) => {
    const parts = path.split(".");
    let node = ui[lang];
    for (const p of parts) node = node?.[p];
    if (node === undefined) {
      let fb = ui.de;
      for (const p of parts) fb = fb?.[p];
      return fb ?? path;
    }
    return node;
  }, [lang]);

  // dynamic content translation (German stored value -> English)
  const tc = useCallback((text) => {
    if (lang === "de" || !text) return text;
    return contentMap[text] || text;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tc }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
